<template lang="html">
  <div class="full-screen">
    <div class="loading-container">
      <span class="loading-text">Loading</span>
      <pulse-loader size="20px" margin="5px" radius="10%" color="#9c27b0"></pulse-loader>
    </div>
  </div>
</template>

<script>
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

export default {
  name: "DashboardLoader",
  components: {
    PulseLoader
  },
  mounted() {
    let adminGroups = JSON.parse(window.localStorage.getItem("adminGroups"));

    /*
     TODO: rewrite this if we are generating side-links automatically
           https://git.payampardaz.com/saman/saman-dashboard/-/issues/44
    */
    if (adminGroups.includes("application_admins") || adminGroups.includes("viewer_admins"))
      this.$router.push("/dashboard");
    else if (adminGroups.includes("server_admins")) this.$router.push("/server-info");
    else this.$router.push("/login"); // Not a valid adminGroup
  },
};
</script>

<style lang="scss" scoped>
.full-screen {
  margin: 0;
  width: 100vw;
  height: 100vh;
  text-align: center;
}

.loading-text {
  font-size: 5em;
  margin-bottom: 32px;
  display: inline-block;
}

.loading-container {
  padding-top: calc(50vh - 55px);
}
</style>
